<template>
  <iRow>
    <iRow align="center">
      <iDisplayText variant="small">
        Something went wrong
      </iDisplayText>
    </iRow>
    <iRow align="center">
      <iParagraph text-align="center">
        Please wait a few seconds and then refresh the page. If this keeps happening please contact support with the error id below
      </iParagraph>
    </iRow>
    <iRow align="center">
      <iText>Error ID: {{ errorId }}</iText>
    </iRow>
    <iRow v-if="debugMode" align="center" class="debug-section">
      <iDisplayText variant="verySmall">
        Errors
      </iDisplayText>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Message</th>
            <th>File</th>
            <th>Line</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <pre>0</pre>
            </td>
            <td>
              <pre>{{ message }}</pre>
            </td>
            <td>
              <pre>+{{ line }} {{ file }}</pre>
            </td>
            <td>
              <pre>{{ line }}</pre>
            </td>
            <td>
              <pre>{{ data }}</pre>
            </td>
          </tr>
          <tr v-for="(previousError, index) in previous" :key="index">
            <td>
              <pre>{{ index + 1 }}</pre>
            </td>
            <td>
              <pre>{{ previousError.message }}</pre>
            </td>
            <td>
              <pre>+{{ previousError.line }} {{ previousError.file }}</pre>
            </td>
            <td>
              <pre>{{ previousError.line }}</pre>
            </td>
            <td>
              <pre>{{ previousError.data }}</pre>
            </td>
          </tr>
        </tbody>
      </table>
      <iDisplayText variant="verySmall">
        Stacktrace
      </iDisplayText>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>File</th>
            <th>Line</th>
            <th>Class</th>
            <th>Function</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(frame, index) in stacktrace" :key="index">
            <td>
              <pre>{{ index }}</pre>
            </td>
            <td>
              <pre>+{{ frame.line }} {{ frame.file }}</pre>
            </td>
            <td>
              <pre>{{ frame.line }}</pre>
            </td>
            <td>
              <pre>{{ frame.class }}</pre>
            </td>
            <td>
              <pre>{{ frame.function }}</pre>
            </td>
          </tr>
        </tbody>
      </table>
      <iSpace :height="10" />
    </iRow>
    <iRow v-else align="center">
      <iLink href="https://inspirationco.freshdesk.com/support/tickets/new" target="_blank">
        <iButton>Contact Support</iButton>
      </iLink>
    </iRow>
  </iRow>
</template>

<script>
export default {
  name: "Error",
  props: {
    errorId: {
      type: String,
      required: false,
      default: "",
    },
    debugMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    stacktrace: {
      type: Array,
      required: false,
      default: () => [],
    },
    message: {
      type: String,
      required: false,
      default: "",
    },
    file: {
      type: String,
      required: false,
      default: "",
    },
    line: {
      type: Number,
      required: false,
      default: 0,
    },
    previous: {
      type: Array,
      required: false,
      default: () => [],
    },
    data: {
      type: Array,
      required: false,
      default: () => ({}),
    },
  },
  styleGuide: () => ({
    tableFontColor: { "color.font": "standard" },
  }),
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: left;
  vertical-align: top;
  color: v-bind("$getStyles.tableFontColor");
}

pre {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: monospace;
  margin: 0;
  color: v-bind("$getStyles.tableFontColor");
}

.debug-section {
  margin-left: 20px;
  margin-right: 20px;
}
</style>
